import { useLocation } from 'react-router-dom';
import { LoginConnectorApollo, UserDataConnectorApollo } from '@front-activerse/common-components';
import AuthLoginByEmailAndPasswordContainer from './AuthLoginByEmailAndPasswordContainer';

export const AuthLoginByEmailAndPasswordPage = ({
  displayAppleButton = true,
  displayFacebookButton = true,
  displayGoogleButton = true,
  registerButtonURL,
  redirectToPathAfterSuccessFromRoute = '',
  action,
}) => {
  const location = useLocation();
  const isLoggedIn = !!localStorage.getItem('token');

  let redirectToPathAfterSuccess = location.state?.from?.pathname || '/';

  if (redirectToPathAfterSuccess === '/auth/logout') {
    redirectToPathAfterSuccess = '/';
  }

  if (redirectToPathAfterSuccessFromRoute) {
    redirectToPathAfterSuccess = redirectToPathAfterSuccessFromRoute;
  }

  global.localStorage.setItem('redirectToPathAfterSuccess', redirectToPathAfterSuccess);

  return (
    <LoginConnectorApollo>
      {({ ...login }) => (
        <UserDataConnectorApollo>
          {({ ...userDataOnDemand }) => (
            <AuthLoginByEmailAndPasswordContainer
              {...login}
              {...userDataOnDemand}
              isLoggedIn={isLoggedIn}
              redirectToPathAfterSuccess={redirectToPathAfterSuccess}
              displayAppleButton={displayAppleButton}
              displayFacebookButton={displayFacebookButton}
              displayGoogleButton={displayGoogleButton}
              registerButtonURL={registerButtonURL}
              action={action}
            />
          )}
        </UserDataConnectorApollo>
      )}
    </LoginConnectorApollo>
  );
};

export default AuthLoginByEmailAndPasswordPage;
